import React, { useState, useMemo } from "react";
import { Box, Collapse } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { MaterialTableLineItems } from "./MaterialTableLineItems";
import { sortPosition, fmtINR } from "../../../../util/helper";
import SubGroupRow from "./SubGroupRow";
import { Button } from "react-bootstrap";
import { exitSelectedPositionsAction } from "../../../../redux/actions/packageAction";

const SingleLegGroupRow = ({
  group,
  columns,
  isBasketAdded,
  source,
  info,
  inputValues,
  buySellClick,
  updateBasket,
  handleChange,
  checkedId,
  isClosedPosition,
  isDark,
  groupingMode,
  subGroupingMode
}) => {
  const [open, setOpen] = useState(true);

  const hasSubGroups = group.subGroups && group.subGroups.length > 0;

  const groupKey = String(groupingMode).replace(/[^a-zA-Z0-9]/g, '') + "-" + String(group.name).replace(/[^a-zA-Z0-9]/g, '');

  const hasPositions = useMemo(() => {
    const openPositions = group.data.filter((p) => p.netQuantity !== 0);
    const ce = openPositions.some((p) => p.instrument?.instrumentType === "CE");
    const pe = openPositions.some((p) => p.instrument?.instrumentType === "PE");
    const any = openPositions.length > 0;
    const selected = openPositions.some(p => checkedId?.includes(p.id));
    return { ce, pe, any, selected };
  }, [group.data, checkedId]);

  const handleExitCE = (e) => {
    e.stopPropagation();
    const positionIds = group.data
      .filter(pos => pos.netQuantity !== 0 && pos.instrument?.instrumentType === "CE")
      .map(pos => pos.id);
    if (positionIds.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  const handleExitPE = (e) => {
    e.stopPropagation();
    const positionIds = group.data
      .filter(pos => pos.netQuantity !== 0 && pos.instrument?.instrumentType === "PE")
      .map(pos => pos.id);
    if (positionIds.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  const handleExitAll = (e) => {
    e.stopPropagation();
    const positionIds = group.data
      .filter(pos => pos.netQuantity !== 0)
      .map(pos => pos.id);
    if (positionIds.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  const handleExitSelected = (e) => {
    e.stopPropagation();
    const positionIds = group.data
      .filter(pos => pos.netQuantity !== 0 && checkedId?.includes(pos.id))
      .map(pos => pos.id);
    if (positionIds.length > 0) {
      exitSelectedPositionsAction(info?.broker?.id, positionIds);
    }
  };

  return (
    <div>
      {/* Level-1 group header */}
      <div
        className="basket-pnl-div d-flex cursor-pointer"
        onClick={() => setOpen(!open)}
        style={{
          borderBottomLeftRadius: open ? "0px" : "",
          borderBottomRightRadius: open ? "0px" : "",
        }}
      >
        <div className="pe-0 ps-0">
          <button
            aria-label="expand row"
            className="expand-group-btn"
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: isDark ? "#afb2b6" : "#000" }} />
            ) : (
              <KeyboardArrowRightIcon style={{ color: isDark ? "#afb2b6" : "#000" }} />
            )}
          </button>
        </div>
        <div className="d-flex flex-grow-1 align-items-center">
          <div className="d-flex align-items-center">
            <div className="ins-name">
              {group.name}
            <span 
              id={"group-count-" + groupKey}
              className="ms-2" 
              style={{ fontSize: '11px', opacity: 0.6, color: isDark ? "#afb2b6" : "#4b5563" }}
            >
              ({group.data.filter(i => i.netQuantity !== 0).length}/{group.data.length})
            </span>
            </div>
          </div>

          <div className="d-flex align-items-center gap-4 ms-4 me-3">
            <div className="single-leg-pnl d-flex align-items-center m-0">
              <span style={{ fontSize: "11px", opacity: 0.7, color: isDark ? "#afb2b6" : "#4b5563" }}>Total:</span>
              <span
                id={"group-pnl-" + groupKey}
                className={`ms-1 ${group.totalPNL === 0 ? "" : group.totalPNL > 0 ? "text-success" : "text-danger"}`}
                style={{ fontWeight: 600, fontSize: "13px" }}
              >
                {fmtINR(group.totalPNL)}
              </span>
            </div>

            <div className="single-leg-pnl d-flex align-items-center m-0">
              <span style={{ fontSize: "11px", opacity: 0.7, color: isDark ? "#afb2b6" : "#4b5563" }}>Unrealized:</span>
              <span
                id={"group-u-" + groupKey}
                className={`ms-1 ${group.tolUnrealizedPNL === 0 ? "" : group.tolUnrealizedPNL > 0 ? "text-success" : "text-danger"}`}
                style={{ fontSize: "12px" }}
              >
                {fmtINR(group.tolUnrealizedPNL)}
              </span>
            </div>

            <div className="single-leg-pnl d-flex align-items-center m-0">
              <span style={{ fontSize: "11px", opacity: 0.7, color: isDark ? "#afb2b6" : "#4b5563" }}>Realized:</span>
              <span
                id={"group-r-" + groupKey}
                className={`ms-1 ${group.totaLrealizedPNL === 0 ? "" : group.totaLrealizedPNL > 0 ? "text-success" : "text-danger"}`}
                style={{ fontSize: "12px" }}
              >
                {fmtINR(group.totaLrealizedPNL)}
              </span>
            </div>

            <div className="d-flex btn-exit ms-2 gap-1" style={{ width: hasPositions.selected ? "300px" : "220px" }}>
              <Button
                disabled={!hasPositions.ce}
                onClick={handleExitCE}
                className="text-primary"
                size="sm"
                variant="outline-primary"
                style={{ padding: '1px 6px', fontSize: '11px' }}
              >
                Exit CE
              </Button>
              <Button
                disabled={!hasPositions.pe}
                onClick={handleExitPE}
                className="text-warning"
                size="sm"
                variant="outline-warning"
                style={{ padding: '1px 6px', fontSize: '11px' }}
              >
                Exit PE
              </Button>
              <Button
                disabled={!hasPositions.any}
                onClick={handleExitAll}
                className="text-danger"
                size="sm"
                variant="outline-danger"
                style={{ padding: '1px 6px', fontSize: '11px' }}
              >
                Exit All
              </Button>
              {hasPositions.selected && (
                <Button
                  onClick={handleExitSelected}
                  className="text-danger"
                  size="sm"
                  variant="outline-danger"
                  style={{ padding: '1px 6px', fontSize: '11px', width: "80px" }}
                >
                  Exit Selected
                </Button>
              )}
            </div>
          </div>
        </div>

      </div>

      {/* Level-1 group body */}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box
          className="basket-items"
          style={{ margin: "4px 8px", paddingLeft: "8px" }}
        >
          {hasSubGroups ? (
            group.subGroups.map((subGroup, idx) => (
              <SubGroupRow
                key={subGroup.name + idx}
                subGroup={subGroup}
                columns={columns}
                isBasketAdded={isBasketAdded}
                source={source}
                info={info}
                inputValues={inputValues}
                buySellClick={buySellClick}
                updateBasket={updateBasket}
                handleChange={handleChange}
                checkedId={checkedId}
                isClosedPosition={isClosedPosition}
                isDark={isDark}
                groupingMode={subGroupingMode}
                parentKey={groupKey}
              />
            ))
          ) : (
            <MaterialTableLineItems
              basketId={"undefined"}
              lineItems={sortPosition(group.data, isClosedPosition)}
              columns={columns}
              isBasketAdded={isBasketAdded}
              source={source}
              info={info}
              inputValues={inputValues}
              buySellClick={buySellClick}
              updateBasket={updateBasket}
              handleChange={handleChange}
              checkedId={checkedId}
              isSingleLeg={true}
              isDark={isDark}
            />
          )}
        </Box>
      </Collapse>
    </div>
  );
};

export default SingleLegGroupRow;
